// extracted by mini-css-extract-plugin
export default {"guidelines_main":"Guidelines_guidelines_main__-AlDb","guidelines_heading":"Guidelines_guidelines_heading__adm0Z","guidelines_main_inner":"Guidelines_guidelines_main_inner__dhSjU"};